import axiosInstance from 'utils/axiosInstance';
import { get } from 'lodash/fp';

const getAccountPreferences = () => axiosInstance.get(`/AccountPreferences`).then(get('data'));

const setAccountPreferences = data => axiosInstance.post(`/AccountPreferences`, data).then(get('data'));
const setAccountPassword = data => axiosInstance.post(`Account/UpdatePasswordandTimezone`, data).then(get('data'));

export { getAccountPreferences, setAccountPreferences, setAccountPassword };
